import { SortDirection, TableSort } from "../tables/table";
import { ArrayStringFilterOperator } from "./advanced-filters/array-string-filter";
import { AdvancedFilterType } from "./advanced-filters/generic-advanced-filter-data";
import { AdvancedFilterData, DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum OrderTrackingShipmentsSystemView {
  ALL = "all",
  IN_TRANSIT = "in-transit",
  OUT_FOR_DELIVERY = "out-for-delivery",
  DELIVERED = "delivered",
  EXCEPTIONS = "exceptions",
}

export const orderTrackingShipmentSortDefault: TableSort = {
  direction: SortDirection.DESC,
  key: "firstInTransitAt",
};

const getDeliveryStatusFilter = (statuses: string[]) =>
  ({
    name: "deliveryStatus",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: statuses,
    operator: ArrayStringFilterOperator.ANY_OF,
  }) as AdvancedFilterData;

const defaultColumns = [
  { key: "orderName", width: 150, hidden: false },
  { key: "customerName", width: 150, hidden: false },
  { key: "customerEmail", width: 180, hidden: false },
  { key: "orderDate", width: 130, hidden: false },
  { key: "status", width: 120, hidden: false },
  { key: "trackingNumber", width: 160, hidden: false },
  { key: "carrier", width: 120, hidden: false },
  { key: "deliveryStatus", width: 140, hidden: false },
  { key: "firstInTransitAt", width: 140, hidden: false },
  { key: "estimatedDeliveryAt", width: 140, hidden: false },
];

export const StaticSystemViews: Record<
  OrderTrackingShipmentsSystemView,
  viewTypes["order-tracking-shipments"]
> = {
  [OrderTrackingShipmentsSystemView.ALL]: {
    table: "order-tracking-shipments",
    name: OrderTrackingShipmentsSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingShipmentSortDefault,
    position: 0,
    isNotEditable: true,
  },
  [OrderTrackingShipmentsSystemView.IN_TRANSIT]: {
    table: "order-tracking-shipments",
    name: OrderTrackingShipmentsSystemView.IN_TRANSIT,
    filters: [getDeliveryStatusFilter(["in_transit"])],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingShipmentSortDefault,
    position: 0,
  },
  [OrderTrackingShipmentsSystemView.OUT_FOR_DELIVERY]: {
    table: "order-tracking-shipments",
    name: OrderTrackingShipmentsSystemView.OUT_FOR_DELIVERY,
    filters: [getDeliveryStatusFilter(["out_for_delivery"])],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingShipmentSortDefault,
    position: 0,
  },
  [OrderTrackingShipmentsSystemView.DELIVERED]: {
    table: "order-tracking-shipments",
    name: OrderTrackingShipmentsSystemView.DELIVERED,
    filters: [getDeliveryStatusFilter(["delivered"])],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingShipmentSortDefault,
    position: 0,
  },
  [OrderTrackingShipmentsSystemView.EXCEPTIONS]: {
    table: "order-tracking-shipments",
    name: OrderTrackingShipmentsSystemView.EXCEPTIONS,
    filters: [getDeliveryStatusFilter(["delivery_failure", "delayed"])],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingShipmentSortDefault,
    position: 0,
  },
};

export function friendlyOrderTrackingShipmentViewName(
  viewName: string,
): string {
  switch (viewName) {
    case OrderTrackingShipmentsSystemView.ALL:
      return "All";
    case OrderTrackingShipmentsSystemView.IN_TRANSIT:
      return "In Transit";
    case OrderTrackingShipmentsSystemView.OUT_FOR_DELIVERY:
      return "Out for Delivery";
    case OrderTrackingShipmentsSystemView.DELIVERED:
      return "Delivered";
    case OrderTrackingShipmentsSystemView.EXCEPTIONS:
      return "Exceptions";
    default:
      return viewName;
  }
}
